import { render, staticRenderFns } from "./module1.vue?vue&type=template&id=a19d7b4c&scoped=true"
import script from "./module1.vue?vue&type=script&lang=js"
export * from "./module1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19d7b4c",
  null
  
)

export default component.exports